module.exports = __webpack_public_path__ + "images/pro/icon-pro-large-b009d49b6a5e9c3af367623b90b2ec13.png";